import React from "react";
import {action, observable} from "mobx";

import courierService from "../services/courierService";
import generalReportService from "services/generalReportService";
import appStore from "./appStore";
import config from "../_core/config";
import {b64DecodeToUrl} from "../utils/helpers";
import walletService from "../services/walletService";

import i18n from "../i18n";
import {result} from "lodash";
class courierStore {
    @observable courierDedicationList = [];

    @action getCourierList = async params => {
        const resultOfRequest = await courierService.getCourierList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourier = async params => {
        const resultOfRequest = await courierService.getCourier(params);

        if (resultOfRequest.data.photo) {
            resultOfRequest.data.photoId = resultOfRequest.data.photo;
            resultOfRequest.data.photo = `${config.getBasePublicUrl()}api/panel/v1/image/${
                resultOfRequest.data.photo
            }`;
        }
        return resultOfRequest;
    };

    @action getCourierByTckn = async params => {
        const resultOfRequest = await courierService.getCourierByTckn(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getDedicationList = async params => {
        const resultOfRequest = await courierService.getDedicationList(params);
        return resultOfRequest;
    };

    @action updateCourier = async params => {
        const resultOfRequest = await courierService.updateCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateCourier.successMessageContent", {ns: "common"})
        });
        return true;
    };

    @action checkProviderCompany = async ({courierId, ...body}) => {
        const resultOfRequest = await courierService.checkCourierProviderCompany(courierId, body);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return null;
        }
        return resultOfRequest.data;
    };

    @action updateProviderCompany = async ({courierId, ...body}) => {
        const resultOfRequest = await courierService.updateCourierProviderCompany(courierId, body);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateCourier.successMessageContent", {ns: "common"})
        });
        return true;
    };

    @action createCourier = async params => {
        const resultOfRequest = await courierService.createCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.createCourier.successMessageContent", {ns: "common"})
        });
        return resultOfRequest.data;
    };

    @action createCourierCandidate = async params => {
        const resultOfRequest = await courierService.createCourierCandidate(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({content: "Aday kurye başarıyla oluşturuldu."});
        return resultOfRequest.data;
    };

    @action uploadImage = async params => {
        const resultOfRequest = await courierService.uploadImage(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action updateStatus = async params => {
        const resultOfRequest = await courierService.updateStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };

    @action updateCourierDocumentStatus = async params => {
        const resultOfRequest = await courierService.updateCourierDocumentStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };

    @action createCourierCallRecords = async params => {
        const resultOfRequest = await courierService.createCourierCallRecords(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Arama kaydı başarıyla oluşturuldu."
        });
        return true;
    };

    @action updateCourierCallRecords = async params => {
        const resultOfRequest = await courierService.updateCourierCallRecords(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Arama notu başarıyla güncellendi."
        });
        return true;
    };

    @action getCourierCallStatuses = async params => {
        const resultOfRequest = await courierService.getCourierCallStatuses();
        if (resultOfRequest.status !== 200) {
            return [];
        }
        return resultOfRequest.data;
    };
    /* 
    will be removed on backend
    @action createCourierEquipmentRequests = async params => {
        const resultOfRequest = await courierService.createCourierEquipmentRequests(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Ekipman talebi başarıyla oluşturuldu."
        });
        return true;
    }; */

    @action rejectOnboardingDocumentVerificationStatus = async params => {
        const resultOfRequest = await courierService.rejectOnboardingDocumentVerificationStatus(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };
    @action completeTrainingPhase = async params => {
        const resultOfRequest = await courierService.completeTrainingPhase(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };
    @action completeShiftWaitingPhase = async params => {
        const resultOfRequest = await courierService.completeShiftWaitingPhase(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };
    @action completeOnboardingDocumentPhase = async params => {
        const resultOfRequest = await courierService.completeOnboardingDocumentPhase(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };
    @action blockCourier = async params => {
        const resultOfRequest = await courierService.blockCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye kara listeye alındı."
        });
        return true;
    };
    @action unblockCourier = async params => {
        const resultOfRequest = await courierService.unblockCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye kara listeden çıkarıldı."
        });
        return true;
    };
    @action rejectCourierApplication = async params => {
        const resultOfRequest = await courierService.rejectCourierApplication(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye kalıcı olarak reddedildi."
        });
        return true;
    };
    @action undoCourierRejection = async params => {
        const resultOfRequest = await courierService.undoCourierRejection(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye reddi geri alındı."
        });
        return true;
    };
    @action getDocumentsProgress = async params => {
        const resultOfRequest = await courierService.getDocumentsProgress(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCourierDocumentsRejectHistory = async params => {
        const resultOfRequest = await courierService.getCourierDocumentsRejectHistory(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCourierDocumentsHistory = async params => {
        const resultOfRequest = await courierService.getCourierDocumentsHistory(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCourierDocumentRejectionCounts = async params => {
        const resultOfRequest = await courierService.getCourierDocumentRejectionCounts(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action changePassword = async params => {
        const resultOfRequest = await courierService.changePassword(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.changePassword.successMessageContent", {
                ns: "common"
            })
        });
        return true;
    };

    @action getCourierMapList = async params => {
        const resultOfRequest = await courierService.getCourierMapList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getCourierStatusLogs = async params => {
        const resultOfRequest = await courierService.getCourierStatusLogs(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getDedicationsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getDedicationsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getFeedbacksReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getFeedbacksReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getSubCompaniesReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getSubCompaniesReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getCourierReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getCourierReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data?.fileUrl || "";
    };

    @action getCourierReportColumns = async () => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getCourierReportColumns();
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getShiftsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getShiftsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getDailyShiftsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getDailyShiftsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getHoursReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getHoursReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }

        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action uploadCourierFile = async params => {
        const resultOfRequest = await courierService.uploadCourierFile(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action getPoolCouriers = async params => {
        const resultOfRequest = await courierService.getPoolCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getCouriersOfCompany = async params => {
        const resultOfRequest = await courierService.getCouriersOfCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action dedicateCompanyCouriers = async params => {
        const resultOfRequest = await courierService.dedicateCompanyCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action courierDedicationLog = async params => {
        const resultOfRequest = await courierService.courierDedicationLog(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getCourierOnboardingStatusLogs = async params => {
        const resultOfRequest = await courierService.getCourierOnboardingStatusLogs(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectCities = async params => {
        const resultOfRequest = await courierService.getMultipleSelectCities(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectCompanies = async params => {
        const resultOfRequest = await courierService.getMultipleSelectCompanies(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectSubCompanies = async params => {
        const resultOfRequest = await courierService.getMultipleSelectSubCompanies(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action courierUpdateDedication = async params => {
        const resultOfRequest = await courierService.courierUpdateDedication(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            appStore.showSuccessMessage({
                content: i18n.t("stores.courier.courierUpdateDedication.successMessageContent", {
                    ns: "common"
                })
            });
            return resultOfRequest.data;
        }
    };

    @action updateAllCouriersDisable = async params => {
        const resultOfRequest = await courierService.updateAllCouriersDisable(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            appStore.showSuccessMessage({
                content: i18n.t("stores.courier.updateAllCouriersDisable.successMessageContent", {
                    ns: "common"
                })
            });
            return resultOfRequest.data;
        }
    };

    @action getDeliveryLocations = async params => {
        const resultOfRequest = await courierService.getDeliveryLocations(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getCurrentDelivery = async params => {
        const resultOfRequest = await courierService.getCurrentDelivery(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getSlotCouriers = async params => {
        const resultOfRequest = await courierService.getSlotCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data;
        }
    };

    @action getAvailableCouriersForPreferredCourier = async (params, allCityCouriers = true) => {
        const resultOfRequest = await courierService.getAvailableCouriersForPreferredCourier(
            params,
            allCityCouriers
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data.result;
        }
    };

    @action listAvailableCouriers = async params => {
        const resultOfRequest = await courierService.listAvailableCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data.result;
        }
    };

    @action getCourierHomeLocation = async params => {
        const resultOfRequest = await courierService.getCourierHomeLocation(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };
    @action getCourierShifts = async params => {
        const resultOfRequest = await courierService.getCourierShifts(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };
    @action getDedicatedCourier = async params => {
        const resultOfRequest = await courierService.getDedicatedCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action updateShiftSuggestionOptions = async params => {
        const resultOfRequest = await courierService.updateShiftSuggestionOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            appStore.showSuccessMessage({
                content: "Vardiya öneri ayarları değiştirildi."
            });
            return resultOfRequest.data;
        }
    };
    @action updateCourierTransferCenter = async params => {
        const resultOfRequest = await courierService.updateCourierTransferCenter(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getCourierTerminals = async params => {
        const resultOfRequest = await courierService.getCourierTerminals(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getShiftEditLogsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getShiftEditLogsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action updateCourierTerminal = async params => {
        const resultOfRequest = await courierService.updateCourierTerminal(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action getCourierInfo = async params => {
        const resultOfRequest = await courierService.getCourierInfo(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data.result;
    };

    @action getCustomerMapList = async params => {
        const resultOfRequest = await courierService.getCustomerMapList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action listMotorTypes = async params => {
        const resultOfRequest = await courierService.listMotorTypes(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data.result;
        }
    };
    @action listWorkingModels = async params => {
        const resultOfRequest = await courierService.listWorkingModels(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data;
        }
    };

    @action listDrivingLicenseTypes = async params => {
        const resultOfRequest = await courierService.listDrivingLicenseTypes(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getOnboardingDocumentCount = async () => {
        const resultOfRequest = await courierService.getOnboardingDocumentCount();
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action deactivateCourierWallet = async (courierId, {reason}) => {
        const resultOfRequest = await courierService.deactivateCourierWallet(courierId, {reason});
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (!resultOfRequest.data.success) {
            appStore.openErrorModal({
                content:
                    resultOfRequest.data.message || "Cüzdan deaktive edilirken bir hata oluştu."
            });
            return false;
        }
        appStore.showSuccessMessage({
            content: "Cüzdan deaktive edildi."
        });
        return true;
    };

    @action activateCourierWallet = async (courierId, {reason}) => {
        const resultOfRequest = await courierService.activateCourierWallet(courierId, {reason});
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        if (!resultOfRequest.data.success) {
            appStore.openErrorModal({
                content: resultOfRequest.data.message || "Cüzdan aktive edilirken bir hata oluştu."
            });
            return false;
        }
        appStore.showSuccessMessage({
            content: "Cüzdan aktive edildi."
        });
        return true;
    };

    @action getCourierDeviceInfoHistory = async params => {
        const resultOfRequest = await courierService.getCourierDeviceInfoHistory(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };
    @action downloadDocument = async (courierId, documentType) => {
        try {
            const resultOfRequest = await courierService.downloadDocument(courierId, documentType);

            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data?.message});
                return false;
            }
            const downloadedDoc = resultOfRequest.data?.document;
            if (!downloadedDoc?.success) {
                appStore.openErrorModal({content: downloadedDoc?.message || "Belge indirilemedi."});
                return false;
            }
            const base64Data = downloadedDoc.data;
            const mimeType = downloadedDoc.mimeType;
            const fileName = downloadedDoc.fileName;
            return {base64Data, mimeType, fileName};
        } catch (error) {
            appStore.openErrorModal({content: "Belge indirilemedi."});
            return false;
        }
    };
    @action downloadAllDocuments = async courierId => {
        try {
            const resultOfRequest = await courierService.downloadAllDocuments(courierId);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data?.message});
                return false;
            }

            const downloadedDoc = resultOfRequest.data?.document;
            if (!downloadedDoc?.success) {
                appStore.openErrorModal({content: downloadedDoc?.message || "Belge indirilemedi."});
                return false;
            }

            return {
                success: downloadedDoc.success,
                base64Data: downloadedDoc.base64Data,
                mimeType: downloadedDoc.mimeType,
                fileName: downloadedDoc.fileName
            };
        } catch (error) {
            appStore.openErrorModal({content: "Belge indirilemedi."});
            return false;
        }
    };
    @action checkInvoiceStatus = async courierId => {
        const resultOfRequest = await walletService.checkInvoiceStatus(courierId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action checkInvoiceIdStatus = async invoiceId => {
        const resultOfRequest = await walletService.checkInvoiceIdStatus(invoiceId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action checkPaymentIdStatus = async invoiceId => {
        const resultOfRequest = await walletService.checkPaymentIdStatus(invoiceId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action createGetirImageWebhook = async params => {
        const resultOfRequest = await courierService.createGetirImageWebhook(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action sendCourierToAccounting = async courierId => {
        const resultOfRequest = await courierService.sendCourierToAccounting(courierId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye bilgileri başarıyla muhasebeye gönderildi."
        });
        return true;
    };

    @action getCourierNotifications = async (courierId, params) => {
        const resultOfRequest = await courierService.getCourierNotifications(courierId, params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false, data: {notifications: [], pagination: {}}};
        }
        return resultOfRequest.data;
    };

    @action sendTestNotification = async courierId => {
        const resultOfRequest = await courierService.sendTestNotification(courierId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        return resultOfRequest.data;
    };

    @action sendToEvaluation = async (courierId, formData) => {
        const resultOfRequest = await courierService.sendToEvaluation(courierId, formData);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.showSuccessMessage({content: "Kurye değerlendirme sürecine alındı."});
        return {success: true, data: resultOfRequest.data};
    };

    @action cancelEvaluation = async courierId => {
        const resultOfRequest = await courierService.cancelEvaluation(courierId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.showSuccessMessage({content: "Değerlendirme iptal edildi."});
        return {success: true, data: resultOfRequest.data};
    };

    @action sendToTermination = async courierId => {
        const resultOfRequest = await courierService.sendToTermination(courierId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.showSuccessMessage({content: "Kurye işten çıkarma bekliyor statüsüne alındı."});
        return {success: true, data: resultOfRequest.data};
    };

    @action terminateCourier = async (courierId, formData) => {
        const resultOfRequest = await courierService.terminateCourier(courierId, formData);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.showSuccessMessage({content: "Kurye işten çıkarıldı."});
        return {success: true, data: resultOfRequest.data};
    };

    @action startLeave = async (courierId, {startDate, endDate, reason}) => {
        const resultOfRequest = await courierService.startLeave(courierId, {
            startDate,
            endDate,
            reason
        });
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.showSuccessMessage({content: "Kurye izinli statüsüne alındı."});
        return {success: true, data: resultOfRequest.data};
    };

    @action endLeave = async courierId => {
        const resultOfRequest = await courierService.endLeave(courierId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.showSuccessMessage({content: "Kurye izni sonlandırıldı."});
        return {success: true, data: resultOfRequest.data};
    };

    @action getLeaveHistory = async courierId => {
        const resultOfRequest = await courierService.getLeaveHistory(courierId);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false, data: []};
        }
        return {success: true, data: resultOfRequest.data?.items || []};
    };

    @action sendAnnouncementToFilteredCouriers = async params => {
        const resultOfRequest = await courierService.sendAnnouncementToFilteredCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.openSuccessModal({
            title: resultOfRequest.data.message
        });
        return {success: true, data: resultOfRequest.data};
    };

    @action sendWhatsappToFilteredCouriers = async params => {
        const resultOfRequest = await courierService.sendWhatsappToFilteredCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {success: false};
        }
        appStore.openSuccessModal({
            title: resultOfRequest.data.message
        });
        return {success: true, data: resultOfRequest.data};
    };

    @action sendAnnouncementWithExcel = async formData => {
        const resultOfRequest = await courierService.sendAnnouncementWithExcel(formData);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data?.result?.message});
            return {success: false};
        }
        appStore.openSuccessModal({
            title: resultOfRequest.data?.result?.message
        });
        return {success: true, data: resultOfRequest.data};
    };

    @action sendWhatsappAnnouncementWithExcel = async formData => {
        const resultOfRequest = await courierService.sendWhatsappAnnouncementWithExcel(formData);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data?.result?.message});
            return {success: false};
        }
        appStore.openSuccessModal({
            title: resultOfRequest.data?.result?.message
        });
        return {success: true, data: resultOfRequest.data};
    };
}

export default new courierStore();
